// Date inputs must stay empty when no value exists (never default to today).
// This is intentional and applies to both core steps and dynamic extension steps.
// Decision reference: PRD F002 (docs/f002-inputs-refactor/f002-inputs-refactor-prd.md).
export const DATE_FORMAT = "dd/MM/yyyy" as const;